<template>
  <!--
    ตรวจรายชื่อพนักงานราชการซ้ำ/ค้าง (ทะเบียนบุคคลที่ไม่อยู่ในกรอบอัตรา) — govem_data_quality.php
    admin = true: ทั้งประเทศ แก้ได้ทุกประเภท กู้คืนได้ · admin = false: เฉพาะหน่วยงานตนเอง (เซิร์ฟเวอร์บังคับจาก session)
  -->
  <div>
    <v-alert
      v-if="items.length || admin"
      :type="items.length ? 'warning' : 'success'"
      dense
      outlined
      class="mb-3"
    >
      <div class="d-flex align-center flex-wrap" style="gap:8px">
        <span v-if="items.length">
          <strong>พบรายชื่อพนักงานราชการที่ไม่อยู่ในกรอบอัตรา {{ items.length }} รายการ</strong>
          (ซ้ำ/เลขบัตรผิด/พ้นสภาพแล้วแต่ยังค้าง) — ทำให้รายชื่อซ้ำในหน้าข้อมูลบุคคลและหน้าประเมิน
        </span>
        <span v-else>ไม่พบรายชื่อพนักงานราชการซ้ำ/ค้าง</span>
        <v-spacer />
        <v-btn small :color="items.length ? 'warning' : 'success'" outlined :loading="loading" @click="open">
          <v-icon small left>mdi-account-search</v-icon>ตรวจสอบและแก้ไข
        </v-btn>
      </div>
    </v-alert>

    <v-dialog v-model="dialog" max-width="1200" scrollable>
      <v-card>
        <v-toolbar dense dark flat color="orange darken-3" class="flex-grow-0">
          <v-icon left>mdi-account-alert</v-icon>
          <v-toolbar-title class="subtitle-1">รายชื่อพนักงานราชการซ้ำ/ค้าง (ไม่อยู่ในกรอบอัตรา)</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" class="flex-grow-0">
          <v-tab>รายการที่พบ ({{ items.length }})</v-tab>
          <v-tab @click="loadLog">ประวัติการแก้ไข</v-tab>
        </v-tabs>
        <v-card-text class="pt-3" style="height:70vh">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-alert type="info" dense text class="caption">
                <strong>รวมรายการ</strong> = รายชื่อซ้ำกับคนในกรอบของหน่วยงานเดียวกัน (เลขบัตรพิมพ์ผิด/สลับหลัก) ระบบย้ายประวัติ
                (ผลประเมิน การลา ฯลฯ) ไปที่เลขบัตรที่ถูกต้อง แล้วลบแถวซ้ำ ·
                <strong>ลบรายการค้าง</strong> = พ้นสภาพแล้วแต่ยังค้างในทะเบียน ·
                ประเภทอื่นให้ส่วนกลางตรวจสอบ · ทุกการลบเก็บสำเนาไว้ ส่วนกลางกู้คืนได้
              </v-alert>
              <div class="d-flex flex-wrap mb-2" style="gap:6px">
                <v-chip
                  v-for="c in categoryChips"
                  :key="c.key"
                  small
                  :outlined="filter !== c.key"
                  :color="c.color"
                  :dark="filter === c.key"
                  @click="filter = filter === c.key ? null : c.key"
                >
                  {{ c.text }} {{ c.count }}
                </v-chip>
              </div>
              <v-data-table :headers="headers" :items="filtered" :loading="loading" dense :items-per-page="25" :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }" item-key="id_card">
                <template v-slot:[`item.full_name`]="{ item }">
                  <div class="font-weight-medium">{{ item.full_name }}</div>
                  <div class="caption">
                    {{ item.id_card }}
                    <v-chip x-small :color="item.id_valid ? 'success' : 'error'" dark class="ml-1">
                      {{ item.id_valid ? "เลขบัตรถูกต้อง" : "เลขบัตรไม่ถูกต้อง" }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:[`item.college_name`]="{ item }">
                  {{ item.college_name }}<div class="caption grey--text">{{ item.college_code }}</div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                  <v-chip x-small dark :color="cat(item.category).color">{{ cat(item.category).text }}</v-chip>
                </template>
                <template v-slot:[`item.advice`]="{ item }">
                  <div class="caption" style="max-width:360px;white-space:normal">{{ item.advice }}</div>
                  <div v-if="item.match" class="caption grey--text">
                    ในกรอบ: {{ item.match.id_card }}
                    ({{ item.match.id_valid ? "เลขบัตรถูกต้อง" : "เลขบัตรไม่ถูกต้อง" }}) · ตำแหน่ง {{ item.match.id_position }}
                  </div>
                  <div v-if="Object.keys(item.linked || {}).length" class="caption purple--text">
                    ประวัติผูก: {{ Object.entries(item.linked).map(([t, n]) => t.replace("gov_em_", "") + " " + n).join(", ") }}
                  </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn v-if="item.category === 'typo_duplicate'" x-small color="primary" :loading="busy === item.id_card" @click="resolve(item)">
                    รวมรายการ
                  </v-btn>
                  <v-btn v-else-if="item.category === 'resigned'" x-small color="warning" :loading="busy === item.id_card" @click="resolve(item)">
                    ลบรายการค้าง
                  </v-btn>
                  <v-btn v-else-if="admin" x-small outlined color="error" :disabled="!!Object.keys(item.linked || {}).length"
                    :loading="busy === item.id_card" @click="resolve(item)">
                    ลบรายการ
                  </v-btn>
                  <span v-else class="caption grey--text">แจ้งส่วนกลาง</span>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table :headers="logHeaders" :items="log" dense :items-per-page="25" :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }">
                <template v-slot:[`item.action`]="{ item }">
                  <v-chip x-small dark :color="item.action === 'merge' ? 'primary' : 'warning'">
                    {{ item.action === "merge" ? "รวมรายการ" : "ลบรายการ" }}
                  </v-chip>
                </template>
                <template v-slot:[`item.full_name`]="{ item }">
                  {{ item.full_name }}<div class="caption">{{ item.id_card }}{{ item.target_id_card ? " → " + item.target_id_card : "" }}</div>
                </template>
                <template v-slot:[`item.acted_at`]="{ item }">
                  {{ item.acted_at }}<div class="caption grey--text">{{ item.acted_role === "A" ? "ส่วนกลาง" : "หน่วยงาน" }} #{{ item.acted_by }}</div>
                </template>
                <template v-slot:[`item.restore`]="{ item }">
                  <span v-if="item.restored_at" class="caption">กู้คืนแล้ว {{ item.restored_at }}</span>
                  <v-btn v-else-if="admin" x-small text color="primary" :loading="busy === 'log' + item.id" @click="restore(item)">กู้คืน</v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack.show" :color="snack.color" top :timeout="5000">{{ snack.text }}</v-snackbar>
  </div>
</template>

<script>
const API = "govem_data_quality.php";
const CATS = {
  typo_duplicate: { text: "ซ้ำ (เลขบัตรผิด)", color: "primary" },
  resigned: { text: "พ้นสภาพแล้ว", color: "warning darken-1" },
  same_name: { text: "ชื่อซ้ำ (ตรวจสอบ)", color: "deep-purple" },
  other_college: { text: "ชื่อตรงกับหน่วยงานอื่น", color: "blue-grey" },
  not_in_frame: { text: "ไม่พบในกรอบ", color: "grey darken-1" }
};

export default {
  name: "GovemDataQuality",
  props: { admin: { type: Boolean, default: false } },
  data() {
    return {
      ApiKey: "HRvec2021",
      items: [],
      log: [],
      loading: false,
      dialog: false,
      tab: 0,
      filter: null,
      busy: null,
      snack: { show: false, text: "", color: "success" },
      headers: [
        { text: "ชื่อ-สกุล / เลขบัตร", value: "full_name" },
        { text: "หน่วยงาน", value: "college_name" },
        { text: "ประเภท", value: "category", width: 150 },
        { text: "ข้อเสนอ", value: "advice", sortable: false },
        { text: "", value: "actions", sortable: false, width: 120 }
      ],
      logHeaders: [
        { text: "การแก้ไข", value: "action", width: 110 },
        { text: "ชื่อ-สกุล", value: "full_name" },
        { text: "หน่วยงาน", value: "college_code" },
        { text: "ประเภท", value: "category" },
        { text: "เมื่อ", value: "acted_at" },
        { text: "", value: "restore", sortable: false }
      ]
    };
  },
  computed: {
    filtered() {
      return this.filter ? this.items.filter(i => i.category === this.filter) : this.items;
    },
    categoryChips() {
      return Object.keys(CATS)
        .map(key => ({ key, ...CATS[key], count: this.items.filter(i => i.category === key).length }))
        .filter(c => c.count);
    }
  },
  mounted() {
    this.scan();
  },
  methods: {
    cat(c) {
      return CATS[c] || { text: c, color: "grey" };
    },
    async api(payload) {
      try {
        const res = await this.$http.post(API, { ApiKey: this.ApiKey, ...payload });
        if (!res.data || res.data.status !== true) throw new Error((res.data && res.data.message) || "ไม่ได้รับข้อมูล");
        return res.data;
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message;
        throw new Error(msg || e.message);
      }
    },
    notify(text, color = "success") {
      this.snack = { show: true, text, color };
    },
    async scan() {
      this.loading = true;
      try {
        this.items = (await this.api({ action: "scan" })).items;
        this.$emit("loaded", this.items.length);
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    open() {
      this.dialog = true;
      this.tab = 0;
      this.scan();
    },
    async loadLog() {
      try {
        this.log = (await this.api({ action: "log" })).log;
      } catch (e) {
        this.notify(e.message, "error");
      }
    },
    async resolve(item) {
      const msg = item.category === "typo_duplicate"
        ? `รวม "${item.full_name}" (${item.id_card}) เข้ากับ ${item.match.id_card} ในกรอบ?\nประวัติที่ผูกกับเลขบัตรผิดจะย้ายไปเลขบัตรที่ถูก แล้วลบแถวซ้ำ`
        : `ลบ "${item.full_name}" (${item.id_card}) ออกจากทะเบียนพนักงานราชการ?\n(ระบบเก็บสำเนาไว้ ส่วนกลางกู้คืนได้)`;
      if (!confirm(msg)) return;
      this.busy = item.id_card;
      try {
        const r = await this.api({ action: "resolve", id_card: item.id_card });
        const moved = r.moved && Object.keys(r.moved).length
          ? " · ย้ายประวัติ: " + Object.entries(r.moved).map(([t, n]) => `${t.replace("gov_em_", "")} ${n}`).join(", ")
          : "";
        this.notify((r.action === "merge" ? "รวมรายการเรียบร้อย" : "ลบรายการค้างเรียบร้อย") + moved);
        await this.scan();
        this.$emit("changed");
      } catch (e) {
        this.notify(e.message, "error");
      } finally {
        this.busy = null;
      }
    },
    async restore(row) {
      if (!confirm(`กู้คืน "${row.full_name}" (${row.id_card}) กลับเข้าทะเบียน?`)) return;
      this.busy = "log" + row.id;
      try {
        await this.api({ action: "restore", log_id: row.id });
        this.notify("กู้คืนเรียบร้อย");
        await Promise.all([this.loadLog(), this.scan()]);
        this.$emit("changed");
      } catch (e) {
        this.notify(e.message, "error");
      } finally {
        this.busy = null;
      }
    }
  }
};
</script>
